module.exports = __webpack_public_path__ + "img/no-item.5dddaab1.jpg";